<p-panel header="Filters">
  <ng-template pTemplate="icons">
    <!-- Clear All Filters -->
    @if (activeFilters.length > 0) {
      <p-button label="{{ 'Clear_All' | translateWF: 'Clear All' }}" variant="text" severity="secondary" size="small" icon="pi pi-times" (onClick)="clearAllFilters()"></p-button>
    }
    <p-button
      label="{{ ('Common_Filters' | translate) || 'Filters' }}"
      variant="outlined"
      severity="contrast"
      size="small"
      icon="pi pi-plus"
      (onClick)="menuFiltros.toggle($event)"
    ></p-button>
    <p-menu #menuFiltros [model]="filtersItems" [popup]="true" appendTo="body"></p-menu>
  </ng-template>

  <p-card>
    <div class="filters col">
      <!-- Second Row: Location + Active Filters -->
      <div class="filters__row">
        <!-- Location TreeSelect (only for Roll view) -->
        <div class="filter-item">
          <p-floatlabel variant="on" class="cs-floatlabel-fill cs-floatlabel-label-ellipsis">
            <p-treeSelect
              [options]="locationTreeNodes"
              [(ngModel)]="selectedLocationNodes"
              selectionMode="checkbox"
              class="w-full"
              [showClear]="true"
              appendTo="body"
              (onNodeSelect)="onLocationTreeSelectChange($event)"
              (onNodeUnselect)="onLocationTreeSelectChange($event)"
              (onClear)="onLocationTreeSelectChange($event)"
              [filter]="true"
              [pTooltip]="getTooltip('locationCodes')"
              tooltipPosition="top"
            >
              <ng-template let-node pTemplate="value">
                @if (selectedLocationNodes && selectedLocationNodes.length > 0) {
                  {{ selectedLocationNodes.length }}
                  {{
                    'Production_Locations_Selected'
                      | translateWF
                        : 'location(s)
                selected'
                  }}
                } @else {
                  {{ 'Production_Select_Locations' | translateWF: 'Select Locations' }}
                }
              </ng-template>
            </p-treeSelect>
            <label for="locations">{{ getTranslation('locationCodes') }}</label>
          </p-floatlabel>
        </div>

        <!-- Dynamic Filters -->
        @if (activeFilters.length > 0) {
          <ng-container *ngFor="let customFilter of activeFilters">
            <div
              class="filter-item"
              [class.filter-item--wide]="customFilter.name === 'itemCodes' || customFilter.name === 'workOrderReferences' || customFilter.name === 'fabricCodes'"
            >
              <p-inputgroup>
                <p-inputgroup-addon>
                  <p-button icon="pi pi-times" severity="secondary" variant="text" (click)="removeFilter(customFilter)" [pTooltip]="'Remove filter'" tooltipPosition="top" />
                </p-inputgroup-addon>

                <p-floatlabel variant="on" class="cs-floatlabel-fill cs-floatlabel-label-ellipsis">
                  <!-- Text input -->
                  @if (customFilter.type === 'text') {
                    <input
                      pInputText
                      [id]="customFilter.name"
                      [ngModel]="getFilterValue(customFilter.name)"
                      (ngModelChange)="onFilterValueChange(customFilter.name, $event)"
                      [pTooltip]="getTooltip(customFilter.name)"
                      tooltipPosition="top"
                      class="w-full"
                    />
                  }

                  <!-- Production Card Status multiselect -->
                  @if (customFilter.type === 'multiselect' && customFilter.name === 'statuses') {
                    <p-multiselect
                      [id]="customFilter.name"
                      [options]="statusOptions"
                      [(ngModel)]="selectedStatuses"
                      (onChange)="onStatusChange()"
                      optionLabel="label"
                      optionValue="value"
                      [panelStyle]="{ width: '300px' }"
                      class="w-full"
                      [pTooltip]="getTooltip(customFilter.name)"
                      tooltipPosition="top"
                      appendTo="body"
                    >
                      <ng-template let-option pTemplate="item">
                        <div>{{ option.label }}</div>
                      </ng-template>
                    </p-multiselect>
                  }

                  <!-- Roll Status multiselect -->
                  @if (customFilter.type === 'multiselect' && customFilter.name === 'rollStatuses') {
                    <p-multiselect
                      [id]="customFilter.name"
                      [options]="rollStatusOptions"
                      [(ngModel)]="selectedRollStatuses"
                      (onChange)="onRollStatusChange()"
                      optionLabel="label"
                      optionValue="value"
                      [panelStyle]="{ width: '300px' }"
                      class="w-full"
                      [pTooltip]="getTooltip(customFilter.name)"
                      tooltipPosition="top"
                      appendTo="body"
                    >
                      <ng-template let-option pTemplate="item">
                        <div>{{ option.label }}</div>
                      </ng-template>
                    </p-multiselect>
                  }

                  <!-- Roll Category multiselect -->
                  @if (customFilter.type === 'multiselect' && customFilter.name === 'categories') {
                    <p-multiselect
                      [id]="customFilter.name"
                      [options]="rollCategoryOptions"
                      [(ngModel)]="selectedCategories"
                      (onChange)="onCategoryChange()"
                      optionLabel="label"
                      optionValue="value"
                      [panelStyle]="{ width: '300px' }"
                      class="w-full"
                      [pTooltip]="getTooltip(customFilter.name)"
                      tooltipPosition="top"
                      appendTo="body"
                    >
                      <ng-template let-option pTemplate="item">
                        <div>{{ option.label }}</div>
                      </ng-template>
                    </p-multiselect>
                  }

                  <!-- Roll Quality multiselect -->
                  @if (customFilter.type === 'multiselect' && customFilter.name === 'qualities') {
                    <p-multiselect
                      [id]="customFilter.name"
                      [options]="rollQualityOptions"
                      [(ngModel)]="selectedQualities"
                      (onChange)="onQualityChange()"
                      optionLabel="label"
                      optionValue="value"
                      [panelStyle]="{ width: '300px' }"
                      class="w-full"
                      [pTooltip]="getTooltip(customFilter.name)"
                      tooltipPosition="top"
                      appendTo="body"
                    >
                      <ng-template let-option pTemplate="item">
                        <div>{{ option.label }}</div>
                      </ng-template>
                    </p-multiselect>
                  }

                  <!-- Autocomplete multiselect for reference fields -->
                  @if (customFilter.type === 'autocomplete') {
                    <p-multiselect
                      [id]="customFilter.name"
                      [options]="getFilterOptions(customFilter.name)"
                      (onChange)="onAutocompleteChange(customFilter.name, $event)"
                      (onFilter)="searchAutocompleteOptions(customFilter.name, $event)"
                      optionLabel="name"
                      optionValue="id"
                      [panelStyle]="{ width: customFilter.name === 'itemCodes' || customFilter.name === 'fabricCodes' ? '450px' : '300px' }"
                      class="w-full"
                      [pTooltip]="getTooltip(customFilter.name)"
                      tooltipPosition="top"
                      appendTo="body"
                    >
                      <ng-template let-option pTemplate="item">
                        <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis" [title]="option.name">
                          {{ option.name }}
                        </div>
                      </ng-template>
                    </p-multiselect>
                  }

                  <!-- Label with selected count -->
                  <label [for]="customFilter.name">
                    {{ getTranslation(customFilter.name) }}
                    @if (hasFilterValue(customFilter.name)) {
                      <span class="filter-count">({{ getSelectedCount(customFilter.name) }})</span>
                    }
                  </label>
                </p-floatlabel>
              </p-inputgroup>
            </div>
          </ng-container>
        }
      </div>
    </div>
  </p-card>
</p-panel>
